export const MultiplePagesIcon = (props) => (
  <svg
    width="108"
    height="64"
    viewBox="0 0 108 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.5 2.75V15.75C32.5 16.612 32.8424 17.4386 33.4519 18.0481C34.0614 18.6576 34.888 19 35.75 19H48.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.25 61.25H9.75C8.02609 61.25 6.37279 60.5652 5.15381 59.3462C3.93482 58.1272 3.25 56.4739 3.25 54.75V9.25C3.25 7.52609 3.93482 5.87279 5.15381 4.65381C6.37279 3.43482 8.02609 2.75 9.75 2.75H32.5L48.75 19V54.75C48.75 56.4739 48.0652 58.1272 46.8462 59.3462C45.6272 60.5652 43.9739 61.25 42.25 61.25Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_521_8546)">
      <path
        d="M24.375 28.75H39"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.375 38.5H39"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.375 48.25H39"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 35.25V27.9375C13 27.291 13.2568 26.671 13.7139 26.2139C14.171 25.7568 14.791 25.5 15.4375 25.5C16.084 25.5 16.704 25.7568 17.1611 26.2139C17.6182 26.671 17.875 27.291 17.875 27.9375V35.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 32H17.875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4375 46.625C16.084 46.625 16.704 46.8818 17.1611 47.3389C17.6182 47.796 17.875 48.416 17.875 49.0625C17.875 49.709 17.6182 50.329 17.1611 50.7861C16.704 51.2432 16.084 51.5 15.4375 51.5H13V41.75H15.4375C16.084 41.75 16.704 42.0068 17.1611 42.4639C17.6182 42.921 17.875 43.541 17.875 44.1875C17.875 44.834 17.6182 45.454 17.1611 45.9111C16.704 46.3682 16.084 46.625 15.4375 46.625ZM15.4375 46.625H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M88.5 2.75V15.75C88.5 16.612 88.8424 17.4386 89.4519 18.0481C90.0614 18.6576 90.888 19 91.75 19H104.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.25 61.25H65.75C64.0261 61.25 62.3728 60.5652 61.1538 59.3462C59.9348 58.1272 59.25 56.4739 59.25 54.75V9.25C59.25 7.52609 59.9348 5.87279 61.1538 4.65381C62.3728 3.43482 64.0261 2.75 65.75 2.75H88.5L104.75 19V54.75C104.75 56.4739 104.065 58.1272 102.846 59.3462C101.627 60.5652 99.9739 61.25 98.25 61.25Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip1_521_8546)">
      <path
        d="M80.375 28.75H95"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.375 38.5H95"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.375 48.25H95"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69 35.25V27.9375C69 27.291 69.2568 26.671 69.7139 26.2139C70.171 25.7568 70.791 25.5 71.4375 25.5C72.084 25.5 72.704 25.7568 73.1611 26.2139C73.6182 26.671 73.875 27.291 73.875 27.9375V35.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69 32H73.875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.4375 46.625C72.084 46.625 72.704 46.8818 73.1611 47.3389C73.6182 47.796 73.875 48.416 73.875 49.0625C73.875 49.709 73.6182 50.329 73.1611 50.7861C72.704 51.2432 72.084 51.5 71.4375 51.5H69V41.75H71.4375C72.084 41.75 72.704 42.0068 73.1611 42.4639C73.6182 42.921 73.875 43.541 73.875 44.1875C73.875 44.834 73.6182 45.454 73.1611 45.9111C72.704 46.3682 72.084 46.625 71.4375 46.625ZM71.4375 46.625H69"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_521_8546">
        <rect
          width="39"
          height="39"
          fill="white"
          transform="translate(6.5 19)"
        />
      </clipPath>
      <clipPath id="clip1_521_8546">
        <rect
          width="39"
          height="39"
          fill="white"
          transform="translate(62.5 19)"
        />
      </clipPath>
    </defs>
  </svg>
);
